// extracted by mini-css-extract-plugin
export default {"news":"News_news__xmc2-","news__grid":"News_news__grid__mZSrB","card":"News_card__fCCe+","card__main":"News_card__main__nkBnC","card__overlay":"News_card__overlay__R90DN"};